import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainLayoutComponent } from '../shared/components';

import { HomeComponent } from './home/home.component';

const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      { path: '', component: HomeComponent, data: { title: 'GiftShare – Solutia Simpla si Rapida pentru Cadoul Perfect', description: 'GiftShare este solutia rapida pentru a oferi un card cadou online. Alege un voucher cadou pentru cineva drag sau un gift card cadou ca beneficiu extrasalarial.', footerClass: 'bg-faded-primary' } }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HomeRoutingModule { }

export const components = [
  HomeComponent
];

